export interface TopicItem {
  id: string;
  name: string;
  desc: string;
  cover: string;
  count: number;
}

export const topics: TopicItem[] = [
  {
    id: 'topic-1',
    name: '总决赛高光时刻',
    desc: '年度收官之战精华合集，回看每一个让人起鸡皮疙瘩的巅峰瞬间。',
    cover:
      'https://readdy.ai/api/search-image?query=Crowd%20of%20young%20fans%20cheering%20at%20a%20grand%20final%20competition%20with%20orange%20stage%20lights%20and%20confetti%2C%20energetic%20event%20photography%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-07&orientation=landscape',
    count: 18,
  },
  {
    id: 'topic-2',
    name: '黑马选手图鉴',
    desc: '从素人到顶流，盘点本届大赛最令人惊艳的黑马选手成长轨迹。',
    cover:
      'https://readdy.ai/api/search-image?query=Talented%20young%20performer%20showing%20skills%20on%20a%20variety%20talent%20stage%20with%20warm%20gold%20orange%20lighting%2C%20excited%20expression%2C%20modern%20event%20photography%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-05&orientation=landscape',
    count: 12,
  },
  {
    id: 'topic-3',
    name: '公益直播力量',
    desc: '当流量遇上善意，记录主播们用镜头为乡村与公益带来的真实改变。',
    cover:
      'https://readdy.ai/api/search-image?query=Group%20of%20friendly%20young%20streamers%20volunteering%20at%20a%20charity%20broadcast%20event%20with%20orange%20warm%20tones%2C%20smiling%20faces%2C%20modern%20photography%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-06&orientation=landscape',
    count: 9,
  },
  {
    id: 'topic-4',
    name: '直播间名场面',
    desc: '连麦名场面集结，那些让人笑到缺氧、惊呼带货王的高能片段。',
    cover:
      'https://readdy.ai/api/search-image?query=Livestreamer%20competing%20in%20an%20online%20PK%20battle%20with%20ring%20light%20and%20neon%20orange%20glow%2C%20headset%20and%20microphone%2C%20modern%20streaming%20scene%2C%20clean%20simple%20background&width=800&height=600&seq=wldg-cover-03&orientation=landscape',
    count: 15,
  },
];